<template>
  <div class="cohort-evolution">
    <div class="row" v-if="operations.sheets.length > 0">
      <div class="col-xs-12">
        <h3>
          Téléchargements des fiches
        </h3>
        <div class="panel panel-info">
          <div class="panel-heading">
            <div class="form-inline">
              <div v-for="(op, i) in operations.sheets" :key="`operation-${i}`"
                   class="form-group">
                <btn :class="`btn btn-${op.style}`"
                     @click="op.click"
                     :disabled="downloading || op.disabled">
                  {{ op.label }}
                </btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <h3>Taux d'incidences</h3>
        <div v-if="operations.incidences.click">
          <p>
            Les fiches téléchargées permettent de calculer les taux d'incidences des :
            <ul class="incidences-info">
              <li v-for="op in operations.incidences.infections"
                  :key="`incidences-types-${op.style}`">
                <span :class="`label label-${op.style}`">{{ op.name }}</span>
              </li>
            </ul>
          </p>

          <p>
            Uniquement pour les dénominateurs ...
            <ul class="incidences-info">
              <li>
                déclarés dans les données d'activités : jh, jhi, séances de dialyse, ...
              </li>
              <li v-if="hasExpADI">
                déclarés dans les tableaux d'exposition <span class="label label-expADI">Exp ADI</span> : journées cathéters, journées d'intubation, ...
              </li>
              <li v-for="op in operations.incidences.sheetsDenominators"
                  :key="`incidences-denom-${op.style}`">
                calculés à partir des fiches <span :class="`label label-${op.style}`">{{ op.name }}</span> : journées cathéter, exposition patient, ...
              </li>
            </ul>
          </p>
          <div v-for="v in allowedLists" :key="`allowed-list-${v.key}`" class="allowed-list-container">
            <h4>
              {{ v.title }}
              <btn type="default" size="xs" @click="setAllCheckboxesValueInAllowedList(v, true)">
                Tout sélectionner
              </btn>
              <btn type="default" size="xs" @click="resetAllowedList(v)">
                Réinitialiser
              </btn>

            </h4>
            <div class="allowed-list">
              <sui-checkbox :type="v.type" size="xs"
                            :value="d.selected"
                            :ref="`allowed-list-${v.key}-${d.key}`"
                            @input="toggleAllowed(v.target, d.key)"
                            v-for="d in v.list" :key="`allowed-list-${v.key}-${d.key}`">
                <span v-html="d.label"></span>
              </sui-checkbox>
            </div>
          </div>
          <hr>

          <div class="panel panel-info">
            <div class="panel-heading">
              <div class="form-inline">
              </div>
              <div class="form-inline">
                <div class="form-group">
                  <btn type="success"
                       @click="operations.incidences.click"
                       :disabled="computingIncidences">
                    <strong v-if="incidencesByMo != null">
                      Re-calculer les taux d'incidences
                    </strong>
                    <strong v-else>
                      Calculer les taux d'incidences
                    </strong>
                  </btn>
                </div>
                <div class="form-group">
                  <sui-checkbox v-model="useLastEstablishmentType"
                                type="results" size="sm">
                    Utiliser le dernier type d'établissement déclaré
                  </sui-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p>
            Aucun taux d'incidence ne peut être calculé pour l'instant, veuillez télécharger
            les bactériémies ou les pneumopathies.
          </p>
        </div>
      </div>
    </div>
    <div class="row" v-if="tabs && tabs.length > 0">
      <div class="col-xs-12">
        <h3>
          Évolution
        </h3>

        <tabs :transition-duration="0">
          <tab v-for="tab in tabs"
               :key="`tab-${tab.key}`">
            <div slot="title">
              <span v-html="tab.title"></span>
            </div>
            <sui-evolution-sheet-caracteristics :data="tab.data" :prefix="tab.prefix">
            </sui-evolution-sheet-caracteristics>
          </tab>
          <tab v-if="incidencesByMo">
            <div slot="title">
              Taux d'incidence
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6 col-md-4">
                <h4>Sélection de la caractéristique</h4>
                <div class="form-group">
                  <div class="input-group carac-input">
                    <input required
                           ref="input"
                           id="inputIncs"
                           tabindex="0"
                           class="form-control"
                           type="text"
                           placeholder="Taper le nom de la caractéristique"
                           autocomplete="off"/>
                  </div>
                  <typeahead v-model="focus.model"
                             open-on-focus
                             force-select
                             ignore-case
                             :limit="50"
                             target="#inputIncs"
                             :data="focusList"
                             item-key="value"/>
                </div>
                <btn @click="focus.showList = !focus.showList" size="xs">
                  Liste complète
                </btn>
                <collapse v-model="focus.showList">
                  <table class="table table-responsive table-striped">
                    <tbody>
                    <tr v-for="(fl, i) in focusListDisplay"
                        :key="`focus-list-${i}`">
                      <td :class="`focus-list-${fl.style}`" v-html="fl.value"></td>
                    </tr>
                    </tbody>
                  </table>
                </collapse>
              </div>
              <div v-if="hasMultipleMoGroups" class="col-sm-6 col-xs-12 col-md-4">
                <h4>Sélection des micro organismes</h4>
                <dropdown ref="dropdown" block id="mo-dropdown">
                  <btn type="primary"
                       block
                       :disabled="computingIncidences"
                       class="dropdown-toggle">
                    <span v-html="focusMo.name"></span>
                    <span class="caret"></span>
                  </btn>
                  <template slot="dropdown">
                    <li v-for="(f, i) in moGroupList"
                        :key="`item-mo-${i}`">
                      <a role="button"
                         v-if="f.name != null"
                         @click="focusMo = f"
                         v-html="f.name">
                      </a>
                    </li>
                  </template>
                </dropdown>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-4">
                <h4>Export CSV</h4>
                <btn @click="exportCSV">
                  Export des taux par établissements
                </btn>
                <sui-save-blob :target="csv"></sui-save-blob>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <hr>
              </div>
            </div>
            <div v-if="highlight">
              <sui-evol-carac :sources="incidencesEvolution"
                              :field-info="highlight">

              </sui-evol-carac>
            </div>
          </tab>
        </tabs>
      </div>
    </div>
  </div>
</template>
<script>
import go from '@/gojs/go'
import results from '@/sui/data/results'
import promise from '@/sui/tools/promise'
import search from '@/sui/tools/search'
import assert from '@/sui/tools/assert'
import ice from '@/sui/tools/ice'
import regions from '@/sui/tools/regions'
import computeIncidences from '@/sui/tools/incidence'
import evolution from '@/sui/sc/evolution'
import spread from '@/sui/tools/spread'

import suiSaveBlob from '@/sui/components/saveblob'
import suiCheckbox from '@/sui/components/checkbox'
import suiEvolCarac from '@/sui/components/evolution/caracteristics'
import suiEvolutionSheetCaracteristics from '@/sui/components/evolution/sheetCaracteristics'

import { mapState } from 'vuex'
import stringify from 'csv-stringify'
import clone from 'clone'

// TODO
//
//   - sauvegarder les datasets directement ?
//   - sauvegarder l'état de la page ?
//

const initialSelection = {
  bactden: ['jhc', 'jhi', 'sea', 'kt'],
  pneuden: ['jhc', 'ji'],
  mo: [0]
}

export default {
  name: 'tools-cohorts',

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  data: function () {
    return {
      downloadedSheets: {},
      tab: 0,
      csv: null,
      downloading: false,
      useLastEstablishmentType: false,
      selection: {
        bact: null,
        pneu: null,
        mo: null
      },
      allowed: {
        bact: { den: new Set(initialSelection.bactden) },
        pneu: { den: new Set(initialSelection.pneuden) },
        mo: new Set(initialSelection.mo)
      },
      focus: {
        model: null,
        lastValidModel: null,
        showList: false
      },
      txtAllMo: '',
      focusMo: null
    }
  },

  methods: {
    setAllCheckboxesValueInAllowedList: function (v, checked) {
      for (let i = 0; i !== v.list.length; ++i) {
        const d = v.list[i]
        const key = `allowed-list-${v.key}-${d.key}`
        const refs = this.$refs[key]
        if (refs.length > 0) {
          refs[0].checked = checked
        }
      }
    },

    resetAllowedList: function (v) {
      const list = initialSelection[v.key]
      for (let i = 0; i !== v.list.length; ++i) {
        const d = v.list[i]
        const key = `allowed-list-${v.key}-${d.key}`
        const refs = this.$refs[key]
        if (refs.length > 0) {
          refs[0].checked = list.indexOf(d.key) !== -1
        }
      }
    },

    toggleAllowed: function (target, key) {
      if (target.has(key)) {
        target.delete(key)
      } else {
        target.add(key)
      }
    },

    exportCSV: function () {
      const vm = this
      const result = []
      for (let i = 0; i !== vm.establishmentIncidences.length; ++i) {
        const elt = vm.establishmentIncidences[i]
        const allSurveillanceInfo = {}

        for (let moGroup in elt.incidenceMo) {
          const group = results.microOrganismsGroups.byIndex[moGroup]
          assert.notNull(group)

          const surveillanceData = elt.incidenceMo[moGroup]
          for (let surveillanceID in surveillanceData) {
            let surveillanceInfo = allSurveillanceInfo[surveillanceID]
            if (surveillanceInfo == null) {
              const info = surveillanceData[surveillanceID].estb
              surveillanceInfo = {
                name: info.name,
                finess: info.finess,
                type: results.getEstablishementType(info.type),
                region: regions.getRegion(info.finess).name
              }
              allSurveillanceInfo[surveillanceID] = surveillanceInfo
            }

            const incidences = surveillanceData[surveillanceID].incidences
            for (let j = 0; j !== incidences.length; ++j) {
              const incidence = incidences[j]
              const type = go.denom.isSubPopDenominator(incidence.den)
                ? 'TOUS' : surveillanceInfo.type
              result.push(
                {
                  dataset: elt.dset,
                  year: elt.year,
                  region: surveillanceInfo.region,
                  name: surveillanceInfo.name,
                  finess: surveillanceInfo.finess,
                  type: type,
                  moGroup: group.name.replaceAll(/<[^>]*>/g, ''),
                  disc: incidence.disc,
                  spe: incidence.spe,
                  uf: incidence.uf,
                  mod: incidence.mod,
                  inf: incidence.inf,
                  den: incidence.den,
                  ent: incidence.ent,
                  inc: incidence.inc,
                  num: incidence.num,
                  div: incidence.div,
                  qua: incidence.qua
                }
              )
            }
          }
        }
      }

      stringify(
        result,
        {
          header: true,
          bom: true,
          delimiter: ';',
          columns: [
            { key: 'dataset', header: `Dataset` },
            { key: 'year', header: 'Année' },
            { key: 'region', header: `Région` },
            { key: 'name', header: 'Établissement' },
            { key: 'finess', header: `Finess` },
            { key: 'type', header: `Type d'établissement` },
            { key: 'disc', header: 'Discipline' },
            { key: 'spe', header: `Spécialité` },
            { key: 'uf', header: `Uf` },
            { key: 'mod', header: `Modalité` },
            { key: 'inf', header: `Type d'infection` },
            { key: 'den', header: `Dénominateur` },
            { key: 'moGroup', header: `Micro-organismes` },
            { key: 'ent', header: `Porte d'entrée` },
            { key: 'inc', header: `Taux d'incidence` },
            { key: 'num', header: `Nombre d'infections` },
            { key: 'div', header: `Valeur du dénominateur` },
            { key: 'qua', header: `Qualité` }
          ]
        },

        function (err, output) {
          if (err != null) {
            vm.$notify({
              type: 'danger',
              title: 'Erreur !',
              content: `Impossible d'exporter les données: ${err}.`
            })
          } else {
            setTimeout(
              function () {
                vm.csv = {
                  filename: `COHORTE - EXPORT INCIDENCES PAR ÉTABLISSEMENT.csv`,
                  blob: new Blob([output], { type: 'text/plain' })
                }
              }, 10)
          }
        })
    },

    downloadSheets: function (target) {
      const { selectionDatasets } = this.data
      const { promises, names } = evolution.buildPromisesFromDatasets(
        this.$store,
        target,
        selectionDatasets
      )

      const vm = this
      this.downloading = true
      promise.awaitAll(
        promises,
        (d, r) => {
          vm.downloading = false
          const tables = {}
          const sheets = []
          const years = Object.keys(names)
          assert.equals(years.length, d.length)
          for (let i = 0; i !== d.length; ++i) {
            const list = d[i].v
            let sorted = []
            if (list != null) {
              sorted = list.sort(
                (f, s) => f.surv < s.surv ? -1 : f.surv > s.surv ? 1 : 0
              )
            }

            const y = years[i]
            const dset = names[y]
            sheets.push(
              {
                year: y,
                dset: dset,
                dist: target.distribution,
                vars: target.variables(y),
                list: ice.freeze(sorted)
              }
            )

            tables[y] = target.tables(y)

            vm.$set(
              vm.downloadedSheets,
              target.style, {
                target: target,
                data: {
                  tables: tables,
                  sheets: sheets,
                  surveillanceField: target.surveillanceField,
                  doubles: target.doubles,
                  datasets: names
                }
              }
            )
          }
          if (!target.observation && target.type == null) {
            vm.$nextTick(
              () => vm.assignSheetsToDatasets(target.style)
            )
          }
        },

        (e) => {
          vm.downloading = false
          vm.$notify({
            type: 'danger',
            title: 'Erreur !',
            html: true,
            content: `Une erreur est survenue lors du téléchargement
des bactériémies : <ul><li>${e.join('</li><li>')}</li></ul>`,
            duration: 0
          })
        }
      )
    },

    assignSheetsToDatasets: function (module) {
      const dl = this.downloadedSheets[module]
      if (dl == null) {
        return
      }

      const { selectionDatasets } = this.data

      for (let i = 0; i !== selectionDatasets.length; ++i) {
        const dset = selectionDatasets[i]
        const sheets = dl.data.sheets.find(
          s => s.dset === dset.name
        )

        if (sheets.list.length === 0) {
          continue
        }

        for (let j = 0; j !== dset.list.length; ++j) {
          const d = dset.list[j]
          if (d.mod !== module) {
            continue
          }

          const filteredSheets = sheets.list.filter(
            s => s.sv === d.surv && d.shev.findIndex(sh => sh.id === s.id) !== -1
          )

          assert.equals(filteredSheets.length, d.shev.length)
          d.sheets = filteredSheets
        }
      }
    }
  },

  asyncComputed: {
    incidencesData: {
      get: function () {
        const ei = this.establishmentIncidences
        if (ei == null) {
          return null
        }

        const result = []
        for (let i = 0; i !== this.selection.mo.length; ++i) {
          const group = this.selection.mo[i]
          for (let j = 0; j !== ei.length; ++j) {
            const elt = ei[j]
            result.push(computeIncidences(elt.incidenceMo[group.index], true))
          }
        }

        return Promise.all(result)
      },
      default: null
    },

    establishmentIncidencesData: {
      get: function () {
        const hasBacteremias = this.selection.bact != null
        const hasPneumopathies = this.selection.pneu != null
        if (this.data == null || (!hasBacteremias && !hasPneumopathies)) {
          return null
        }

        const result = []
        const list = []
        const { dsets, selectionDatasets, etypes } = this.data
        const lastEType = this.useLastEstablishmentType

        for (let y in dsets) {
          const allSurvs = this.all[y]
          const c = dsets[y]
          if (c === '') {
            continue
          }

          const bacts = this.selection.bact ? this.selection.bact[c] : null
          const pneus = this.selection.pneu ? this.selection.pneu[c] : null
          if (bacts == null && pneus == null) {
            continue
          }

          const dset = selectionDatasets.find(d => d.name === c)
          if (dset == null) {
            continue
          }

          for (let i = 0; i !== dset.list.length; ++i) {
            const current = dset.list[i]
            const sheets = current.sheets
            if (sheets == null || current.sden != null) {
              continue
            }

            const sden = go.incidences.sheetDenominators(
              parseInt(y),
              current.mod,
              sheets,
              current.peri
            )
            current.sden = sden[0]
          }

          const incidenceMo = {}
          for (let i = 0; i !== this.selection.mo.length; ++i) {
            const group = this.selection.mo[i]
            incidenceMo[group.index] = {}
          }

          const cpl = go.completeDataset(dset.list)
          const dsAll = cpl[0]
          for (let s in dsAll) {
            list.push(
              {
                id: s,
                surv: allSurvs.find(surv => surv.id === s),
                dset: dsAll[s],
                incidenceMo: incidenceMo,
                bacts: bacts,
                pneus: pneus
              }
            )
          }

          result.push(
            {
              dset: c,
              year: y,
              incidenceMo: incidenceMo
            }
          )
        }

        let iteration = 0
        const step = 300 / this.selection.mo.length | 0
        assert(step > 0)
        const vm = this

        return spread(
          () => {
            const min = iteration * step
            const max = min + step > list.length ? list.length : min + step
            for (let i = min; i < max; ++i) {
              const current = list[i]
              const s = current.id
              const surveillance = current.surv
              let estbDset = current.dset.den
              if (!hasPneumopathies) {
                estbDset = estbDset.filter(d => d.key.inf === 'bact')
              } else if (!hasBacteremias) {
                estbDset = estbDset.filter(d => d.key.inf === 'pneu')
              }

              for (let j = 0; j !== estbDset.length; ++j) {
                const d = estbDset[j]
                d.val = d.val.filter(
                  v => {
                    const allowed = vm.allowed[d.key.inf]
                    return allowed.den.has(v.den)
                  }
                )
              }

              const counted = {
                bact: [],
                pneu: []
              }

              if (hasBacteremias) {
                const lower = search.lowerBound(current.bacts, s, 'surv')
                const upper = search.upperBound(current.bacts, s, 'surv')
                for (let j = lower; j !== upper; ++j) {
                  const inf = current.bacts[j]
                  assert.equals(inf.surv, s)
                  counted.bact.push(inf)
                }
              }

              if (hasPneumopathies) {
                const lower = search.lowerBound(current.pneus, s, 'surv')
                const upper = search.upperBound(current.pneus, s, 'surv')
                for (let j = lower; j !== upper; ++j) {
                  const inf = current.pneus[j]
                  assert.equals(inf.surv, s)
                  counted.pneu.push(inf)
                }
              }

              let estb = surveillance.establishment
              if (lastEType) {
                estb = clone(estb)
                estb.type = etypes[estb.finess]
              }

              let zeroCache = null
              for (let j = 0; j !== vm.selection.mo.length; ++j) {
                const group = vm.selection.mo[j]

                const counts = []
                try {
                  if (hasBacteremias) {
                    const bactList = results.microOrganismsGroups.filterSheets(
                      counted.bact, group
                    )
                    counts.push(...go.incidences.countBact(bactList))
                  }

                  if (hasPneumopathies) {
                    const pneuList = results.microOrganismsGroups.filterSheets(
                      counted.pneu, group
                    )
                    counts.push(...go.incidences.countPneu(pneuList))
                  }
                } catch (e) {
                  this.$notify({
                    type: 'danger',
                    title: 'Erreur !',
                    duration: 0,
                    content: `Une erreur est survenue pendant le comptage des
 infections : ${e}.`
                  })
                }

                if (counts.length === 0 && zeroCache != null) {
                  current.incidenceMo[group.index][s] = zeroCache
                  continue
                }

                try {
                  const t = go.incidences.compute(counts, estbDset)
                  const previous = []
                  for (let l = j - 1; l >= 0; --l) {
                    const currentIncidenceMo = current.incidenceMo[l]
                    if (currentIncidenceMo != null) {
                      previous.push(currentIncidenceMo[s].incidences)
                    }
                  }
                  if (previous.length > 0) {
                    for (let k = 0; k !== t.length; ++k) {
                      const incidence = t[k]
                      for (let l = 0; l !== previous.length; ++l) {
                        assert.equals(previous[l].length, t.length, 'wrong sizes')
                        const previousIncidence = previous[l][k]
                        if (previousIncidence.num === incidence.num) {
                          assert(
                            () => {
                              if (incidence.mod !== previousIncidence.mod) {
                                return `${k} not same module ${incidence.mod} / ${previousIncidence.mod}`
                              }

                              if (incidence.disc !== previousIncidence.disc) {
                                return `${k} not same discipline ${incidence.disc} / ${previousIncidence.disc}`
                              }

                              if (incidence.den !== previousIncidence.den) {
                                return `${k} not same denominator ${incidence.den} / ${previousIncidence.den}`
                              }

                              if (incidence.div !== previousIncidence.div) {
                                return `${k} not same divisor ${incidence.div} / ${previousIncidence.div}`
                              }

                              if (incidence.ent !== previousIncidence.ent) {
                                return `${k} not same entrance ${incidence.ent} / ${previousIncidence.ent}`
                              }

                              if (incidence.inf !== previousIncidence.inf) {
                                return `${k} not same infection ${incidence.inf} / ${previousIncidence.inf}`
                              }

                              if (incidence.uf !== previousIncidence.uf) {
                                return `${k} not same uf ${incidence.uf} / ${previousIncidence.uf}`
                              }

                              if (incidence.spe !== previousIncidence.spe) {
                                return `${k} not same spe ${incidence.spe} / ${previousIncidence.spe}`
                              }
                              return null
                            },
                            ''
                          )

                          t[k] = previousIncidence
                          break
                        }
                      }
                    }
                  }

                  const final = {
                    incidences: t,
                    estb: estb
                  }
                  current.incidenceMo[group.index][s] = ice.freeze(final)

                  if (counts.length === 0 && zeroCache == null) {
                    zeroCache = final
                  }
                } catch (e) {
                  this.$notify({
                    type: 'danger',
                    title: 'Test',
                    duration: 0,
                    content: `Une erreur est survenue pendant le calcul des
                     incidences : ${e}.`
                  })
                }
              }
            }

            iteration += 1
            return {
              end: max === list.length,
              final: {
                incidences: result
              }

            }
          },
          15
        )
      },
      default: null
    }
  },

  watch: {
    'focus.model': function (value) {
      if (value != null) {
        this.focus.lastValidModel = value
      }
    }
  },

  computed: {
    ...mapState({
      all: state => state.surveillances.all
    }),

    availableMoGroups: function () {
      const sheets = []
      for (let k in this.downloadedSheets) {
        const item = this.downloadedSheets[k]
        if (item.target.type == null) {
          continue
        }

        for (let i = 0; i !== item.data.sheets.length; ++i) {
          const list = item.data.sheets[i].list
          sheets.push(list)
        }
      }

      return results.microOrganismsGroups.getAvailableGroups(sheets)
    },

    hasMultipleMoGroups: function () {
      return this.moGroupList.length > 1
    },

    incidencesByMo: function () {
      const data = this.incidencesData
      if (data == null || this.$asyncComputed.incidencesData.updating) {
        return null
      }

      const datasetCount = this.establishmentIncidences.length
      const moCount = this.selection.mo.length

      assert.equals(data.length, moCount * datasetCount)
      const result = {}
      for (let i = 0; i !== this.selection.mo.length; ++i) {
        const group = this.selection.mo[i]
        result[group.index] = data.slice(
          i * datasetCount,
          (i + 1) * datasetCount
        )
      }

      return result
    },

    establishmentIncidences: function () {
      const eid = this.establishmentIncidencesData
      if (eid == null) {
        return null
      }
      return eid.incidences
    },

    moGroupList: function () {
      return this.selection.mo
    },

    allowedLists: function () {
      const infs = this.operations.incidences.infections
      const result = []
      for (let i = 0; i !== infs.length; ++i) {
        const inf = infs[i]

        const list = []
        const dens = results.denominators[inf.type]
        for (let den in dens) {
          const label = dens[den].label
          list.push({
            key: den,
            label: label,
            selected: this.allowed[inf.type].den.has(den)
          })
        }
        result.push(
          {
            title: `Dénominateurs (${inf.name})`,
            key: `${inf.type}den`,
            type: inf.style,
            list: list,
            target: this.allowed[inf.type].den
          }
        )
      }

      const allowedMoGroups = []
      for (let i = 0; i !== this.availableMoGroups.length; ++i) {
        const group = this.availableMoGroups[i]
        allowedMoGroups.push(
          {
            key: group.index,
            label: group.name,
            selected: this.allowed.mo.has(group.index)
          }
        )
      }
      if (allowedMoGroups.length > 0) {
        result.push(
          {
            title: `Micro-organismes`,
            key: `mo`,
            type: 'bactADI',
            list: allowedMoGroups,
            target: this.allowed.mo
          }
        )
      }

      return result
    },

    computingIncidences: function () {
      if (this.establishmentIncidences == null) {
        return false
      }

      const i = this.$asyncComputed.establishmentIncidencesData
      if (this.incidencesData == null || i.updating) {
        return true
      }
      const ni = this.$asyncComputed.incidencesData
      return ni.updating
    },

    hasExpADI: function () {
      const { mods } = this.data
      return mods != null && mods.indexOf('expADI') !== -1
    },

    availableOperations: function () {
      const { selectionDatasets } = this.data
      if (selectionDatasets == null) {
        return []
      }

      const types = new Set()
      let pneu = false
      for (let i = 0; i !== selectionDatasets.length; ++i) {
        const dsets = selectionDatasets[i]
        for (let j = 0; j !== dsets.list.length; ++j) {
          const dset = dsets.list[j]
          types.add(dset.mod)

          if (!pneu) {
            pneu = dset.mod === 'reaInfADI' ||
                   (dset.mod === 'expADI' &&
                    dset.pneu != null &&
                    dset.pneu.length > 0)
          }
        }
      }

      const result = [
        evolution.targets[0]
      ]
      if (pneu) {
        result.push(evolution.targets[1])
      }

      for (let i = 2; i !== evolution.targets.length; ++i) {
        const t = evolution.targets[i]
        if (types.has(t.style)) {
          result.push(t)
        }
      }

      return result
    },

    operations: function () {
      const result = {
        sheets: [],
        incidences: {
          infections: [],
          sheetsDenominators: [],
          click: null
        }
      }

      const vm = this

      const infSheets = {}
      for (let i = 0; i !== this.availableOperations.length; ++i) {
        const op = this.availableOperations[i]
        const sheets = this.downloadedSheets[op.style]
        const disabled = sheets != null
        const item = {
          style: op.style,
          label: op.name,
          disabled: disabled,
          click: () => {
            vm.downloadSheets(op)
          }
        }
        result.sheets.push(item)

        if (disabled) {
          if (op.type == null) {
            result.incidences.sheetsDenominators.push(op)
          } else {
            result.incidences.infections.push(op)
            infSheets[op.type] = sheets
          }
        }
      }

      if (result.incidences.infections.length > 0) {
        result.incidences.click = () => {
          for (let key in infSheets) {
            const result = {}
            const infs = infSheets[key].data.sheets
            for (let i = 0; i !== infs.length; ++i) {
              const l = infs[i]
              result[l.dset] = l.list
            }
            vm.$set(vm.selection, key, result)
          }

          const groups = []

          for (let i = 0; i !== this.availableMoGroups.length; ++i) {
            const group = this.availableMoGroups[i]
            if (this.allowed.mo.has(group.index)) {
              groups.push(group)
            }
          }
          vm.$set(vm.selection, 'mo', groups)
          if (groups.length > 0) {
            vm.$set(vm, 'focusMo', groups[0])
          }
        }
      }

      return result
    },

    tabs: function () {
      const result = []

      for (let k in this.downloadedSheets) {
        const s = this.downloadedSheets[k]

        const title = `<span class="label label-${s.target.style}">${s.target.name}</span>`
        result.push(
          {
            key: k,
            title: title,
            data: s.data,
            prefix: s.target.prefix
          }
        )
      }

      return result
    },

    incidencesEvolutionByMo: function () {
      const incidences = this.incidencesByMo
      if (this.data == null || incidences == null) {
        return null
      }

      const resultByMo = {}
      const tables = []
      const keys = new Set()
      for (let mo in this.incidencesByMo) {
        const incidences = this.incidencesByMo[mo]
        const result = []

        let index = 0
        const { dsets, selectionDatasets } = this.data
        for (let y in dsets) {
          const c = dsets[y]
          if (c === '') {
            continue
          }

          const dist = {}
          const dset = selectionDatasets.find(d => d.name === c)
          if (dset != null && incidences.length > 0) {
            const ii = incidences[index]
            if (ii == null) {
              ++index
              continue
            }

            for (let k in ii.popstat) {
              if (k === 'getStatistics') {
                continue
              }

              const list = ii.popstat[k]
              for (let t in list) {
                const v = list[t]
                const key = `${t}.${k}`
                dist[key] = {
                  type: 'mm',
                  sum: v.pop.reduce((a, b) => a + b, 0),
                  total: v.pop.length,
                  values: v.pop,
                  num: v.num,
                  div: v.div,
                  meanp: v.meanp,
                  factor: v.factor
                }
                if (!keys.has(key)) {
                  tables.push(
                    {
                      field: {
                        f: key,
                        t: key
                      },
                      title: t,
                      subtitle: '',
                      value: key
                    }
                  )
                  keys.add(key)
                }
              }
            }

            for (let type in results.establishments) {
              const r = results.flattenIndicators(ii.popstat, type)
              for (let i = 0; i !== r.tables.length; ++i) {
                const table = r.tables[i]
                for (let j = 0; j !== table.list.length; ++j) {
                  const indicator = table.list[j]
                  const key = `${type}.${indicator.f}.ind`
                  if (!keys.has(key)) {
                    tables.push(
                      {
                        field: {
                          f: key,
                          t: indicator.t,
                          v: indicator.v
                        },
                        subtitle: '',
                        title: type,
                        value: key
                      }
                    )
                    keys.add(key)
                  }

                  const indDist = r.dist[indicator.f]
                  if (indDist != null) {
                    dist[key] = indDist
                  }
                }
              }
            }
            ++index
          }

          result.push(
            {
              dset: c,
              year: y,
              dist: dist
            }
          )
        }

        if (result.length > 0) {
          resultByMo[mo] = ice.freeze(result)
        }
      }
      const sortedTables = tables.sort(
        (f, s) => {
          const c = f.title.localeCompare(s.title)
          if (c !== 0) {
            return c
          }

          return f.value.localeCompare(s.value)
        }
      )

      return {
        tables: sortedTables,
        distByMo: resultByMo
      }
    },

    incidencesEvolution: function () {
      const evolution = this.incidencesEvolutionByMo
      const selection = this.focusMo
      if (evolution == null || selection == null) {
        return null
      }

      return evolution.distByMo[selection.index]
    },

    highlight: function () {
      const m = this.focus.lastValidModel
      if (m == null) {
        return null
      }

      const result = {
        f: m.field.f,
        t: m.field.t,
        v: m.field.v
      }
      const mo = this.focusMo
      if (mo == null) {
        return null
      }

      result.t = `${result.t} - ${mo.name}`

      return {
        field: result,
        title: m.title,
        subtitle: m.subtitle
      }
    },

    focusListDisplay: function () {
      const result = []
      const previous = {
        title: '',
        subtitle: ''
      }
      for (let i = 0; i !== this.focusList.length; ++i) {
        const focus = this.focusList[i]
        if (focus.title !== previous.title) {
          result.push({ style: 'title', value: focus.title })
          previous.title = focus.title
          previous.subtitle = ''
        }

        if (focus.subtitle !== previous.subtitle) {
          result.push({ style: 'subtitle', value: focus.subtitle })
          previous.subtitle = focus.subtitle
        }

        result.push({ style: 'value', value: focus.value })
      }
      return result
    },

    focusList: function () {
      if (this.incidencesEvolutionByMo == null) {
        return []
      }

      return ice.freeze(this.incidencesEvolutionByMo.tables)
    }
  },

  components: {
    'sui-evolution-sheet-caracteristics': suiEvolutionSheetCaracteristics,
    'sui-evol-carac': suiEvolCarac,
    'sui-checkbox': suiCheckbox,
    'sui-save-blob': suiSaveBlob
  }
}
</script>
<style scoped lang="less">
@import '~variables';

.cohort-evolution {
  .incidences-info {
    list-style-type: circle;

    .label {
      font-size: 95%;
    }

    li {
      line-height: 2.8rem;
    }

  }
}

.allowed-list-container {
  h4 > .btn {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .allowed-list {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }
}

.carac-input {
  width: 100%;
}

#mo-dropdown {
  width: 100%;
  max-width: 300px;
  .btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }
}

</style>
